const PromoLoading = () => {
  return (
    <div className="PromoLoading">
      <div className="px-lg-5">
        <div className="text-loader shine--load" style={{maxWidth: '80%'}}></div>
        <div className="text-loader shine--load" style={{maxWidth: 300}}></div>
      </div>
      <div className="featured-media">
        <div className="image-loader shine--load"></div>
      </div>
      <div className="px-lg-5">
        <div className="text-loader shine--load" style={{maxWidth: 250}}></div>
        <div className="text-loader shine--load" style={{maxWidth: 200}}></div>
        <div className="text-loader shine--load" style={{maxWidth: 400}}></div>
        <div className="text-loader shine--load" style={{maxWidth: 300}}></div>
        <div className="text-loader shine--load" style={{maxWidth: 350}}></div>
        <div className="text-loader shine--load" style={{maxWidth: 200}}></div>
      </div>
    </div>
  )
}

export default PromoLoading